<div class="wrapper">
  <app-page-info
    [resourceName]="resourceParams.name"
    [loginAndRoles]="loginAndRoles"
  />
  <app-records-table-container
    class="app-records-table-container"
    [resourceParams]="resourceParams"
  />
</div>
